import cc from "classcat"
import { useCombobox } from "downshift"
import { Input, InputProps } from "@stackup/inputs"
import { Fragment, useState } from "react"

export const MONTHS = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
]

const getMonths = (input: string): string[] => {
  const search = input.replace(/^0+/, "").trim().toLowerCase()

  if (!search.length) {
    return []
  }

  return MONTHS.filter((month, index) => {
    return (
      month.toLowerCase().startsWith(search) || (index + 1).toString() == search
    )
  })
}

export const MonthInput = (props: Omit<InputProps, "type">) => {
  const { value, setValue } = props.field
  const [months, setMonths] = useState<string[]>([])

  const {
    isOpen,
    highlightedIndex,
    getComboboxProps,
    getInputProps,
    getItemProps,
    getMenuProps,
  } = useCombobox({
    items: months,
    initialInputValue: value,
    defaultHighlightedIndex: 0,
    onStateChange(changes) {
      if ("selectedItem" in changes) {
        setValue(changes.selectedItem || "")
      } else if ("inputValue" in changes) {
        setValue(changes.inputValue || "")
      }
    },
    onInputValueChange({ inputValue }) {
      setMonths(inputValue ? getMonths(inputValue) : [])
    },
  })

  const renderMonth = (month: string, index: number) => {
    const props = getItemProps({ item: month, index })
    const isHighlighted = highlightedIndex === index
    const className = cc([
      "block-list__item",
      { "block-list__item--highlighted": isHighlighted },
    ])

    return (
      <li key={month} className={className} {...props}>
        {month}
      </li>
    )
  }

  const containerClassName = cc([
    "field__options",
    "block-list",
    "shadow",
    { invisible: !isOpen || !months.length },
  ])

  return (
    <Input
      {...props}
      render={(_, inputProps) => (
        <Fragment>
          <div {...getComboboxProps()}>
            <input {...inputProps} {...getInputProps()} />
          </div>

          <ul {...getMenuProps()} className={containerClassName}>
            {isOpen && months.map(renderMonth)}
          </ul>
        </Fragment>
      )}
    />
  )
}
